import { http, meetingHttp } from '@/server/meetHttpServer.js'

/**
 * 视频模块
 * @return {promise}
 * 
 */
/* 新建会议 */
export const addMeeting = (data) => {
        return http({ url: '/videoMeeting/meeting/addMeeting', method: 'post' }, data)
    }
    /* 查询会议列表 */
export const queryMeetingList = (data) => {
        return http({ url: '/videoMeeting/meeting/queryMeetingList', method: 'post' }, data)
    }
    /* 获取机构 */
export const searchDictionaryInfo = (data) => {
        return http({ url: '/videoMeeting/dictionary/searchDictionaryInfo', method: 'post' }, data)
    }
    /* 获取会议详情 */
export const getMeetingDetail = (data,type) => {
        let newrequest = type ? meetingHttp({ url: '/videoMeeting/meeting/getMeetingDetail' }, data) : http({ url: '/videoMeeting/meeting/getMeetingDetail' }, data)
        return newrequest
    }
    /* 获取会议详情 */
export const getVideoList = (data) => {
        return http({ url: '/videoMeeting/meeting/getVideoList', method: 'post' }, data)
    }
    /* 刷新token */
export const refreshToken = (data) => {
        return http({ url: '/videoMeeting/user/refreshToken', method: 'post' }, data)
    }
    /* 获取材料分类 */
export const getMaterailInfo = (data,type) => {
        let newrequest = type ? meetingHttp({ url: '/videoMeeting/dictionary/searchDictionaryInfo' }, data) : http({ url: '/videoMeeting/dictionary/searchDictionaryInfo' }, data)
        return newrequest
    }
    /* 取消会议 */
export const cancelMediationMeeting = (data) => {
        return http({ url: '/videoMeeting/meeting/mediationMeetingCancel', method: 'post' }, data)
    }
    /* 获取视频记录 */
export const getVideoListDetail = (data) => {
        return http({ url: '/videoMeeting/meeting/getVideoList', method: 'post' }, data)
    }
    /* 视频中上传文件 */
export const saveEnvCaseMaterial = (data,type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/envCaseMaterial/saveEnvCaseMaterial' }, data) : http({ url: '/videoMeeting/envCaseMaterial/saveEnvCaseMaterial' }, data)
        return newrequest
}

/* 视频中上传文件 */
export const delEnvCaseMaterial = (data,type) => {
        let newrequest = type ? meetingHttp({ url: '/videoMeeting/envCaseMaterial/delEnvCaseMaterial' }, data) : http({ url: '/videoMeeting/envCaseMaterial/delEnvCaseMaterial' }, data)
        return newrequest
    }
    /* 会议详情一键下载 */
export const clickAllDownLoad = (id, data,type) => {
        let newrequest = type ? meetingHttp({ url: `/videoMeeting/meeting/clickDownLoad?meetingId=${id}` }, data) : http({ url: `/videoMeeting/meeting/clickDownLoad?meetingId=${id}` }, data)
        return newrequest
    }
    /* 邀请码登录 */
export const inviteEnterWatch = (data) => {
    return http({ url: '/videoMeeting/meeting/inviteWatch', method: 'post' }, data)
}

/* 邀请观摩人 */
export const inviteVisitors = (data,type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/meeting/addMeetingPerson' }, data) : http({ url: '/videoMeeting/meeting/addMeetingPerson' }, data)
    return newrequest
}

/* 当事人会议列表 */
export const queryLitigantMeetingList = (data) => {
        return http({ url: '/videoMeeting/meeting/queryLitigantMeetingList', method: 'post' }, data)
    }
    /* 预约会议获取案件材料 */
export const getCaseEnvCase = (data) => {
        return http({ url: '/videoMeeting/envCaseMaterial/queryEnvCaseMaterial', method: 'post' }, data)
    }
    /* 视屏中结束视屏 */
export const updateEndMeeting = (data) => {
        return http({ url: '/videoMeeting/meeting/closeMediationMeeting', method: 'post' }, data)
    }
    /* 获取笔录接口 */
export const getClerkRecord = (data,type) => {
        let newrequest = type ? meetingHttp({ url: '/videoMeeting/clerkRecord/getClerkRecord' }, data) : http({ url: '/videoMeeting/clerkRecord/getClerkRecord' }, data)
        return newrequest
    }
    /* 保存笔录接口 */
export const saveClerkRecord = (data,type) => {
        let newrequest = type ? meetingHttp({ url: '/videoMeeting/clerkRecord/saveClerkRecord' }, data) : http({ url: '/videoMeeting/clerkRecord/saveClerkRecord' }, data)
        return newrequest
    }
    /* 发送笔录接口 */
export const sendClerkRecord = (data,type) => {
        let newrequest = type ? meetingHttp({ url: '/videoMeeting/clerkRecord/sendClerkRecord' }, data) : http({ url: '/videoMeeting/clerkRecord/sendClerkRecord' }, data)
        return newrequest
    }
    /* 文书确认签名完成信息 */
export const signatureConfirmInfo = (data,type) => {
        let newrequest = type ? meetingHttp({ url: '/videoMeeting/clerkConfirm/signatureConfirmInfo' }, data) : http({ url: '/videoMeeting/clerkConfirm/signatureConfirmInfo' }, data)
        return newrequest
    }
    /* 当事人获取文书签名二维码 */
export const clerkConfirmQrCode = (data,type) => {
        let newrequest = type ? meetingHttp({ url: '/videoMeeting/clerkOpinion/clerkConfirmQrCode' }, data) : http({ url: '/videoMeeting/clerkOpinion/clerkConfirmQrCode' }, data)
        return newrequest
    }
    /* 笔录签署确认完成接口 */
export const clerkConfirm = (documentIds, data, type) => {
        let newrequest = type ? meetingHttp({ url: `/videoMeeting/clerkOpinion/clerkConfirmCos?documentIds=${documentIds}&degree=0` }, data) : http({ url: `/videoMeeting/clerkOpinion/clerkConfirmCos?documentIds=${documentIds}&degree=0` }, data)
        return newrequest
    }
    /* 笔录材料列表 */
export const clerkRecordAttaList = (data,type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/clerkRecord/clerkRecordAttaList' }, data) : http({ url: '/videoMeeting/clerkRecord/clerkRecordAttaList' }, data)
        return newrequest
}

    /* 发送仲裁协议书 */
export const sendArbitrationBook = (data,type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/arbitrationBook/sendArbitrationBook' }, data) : http({ url: '/videoMeeting/arbitrationBook/sendArbitrationBook' }, data)
        return newrequest
}
    /* 发送仲裁协议书和发送笔录 */
export const sendDocBook = (data,type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/docBook/sendDocBook' }, data) : http({ url: '/videoMeeting/docBook/sendDocBook' }, data)
        return newrequest
}

    /* 提交质证 */
export const addEvidence = (data,type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/attachmentEvidence/addEvidence' }, data) : http({ url: '/videoMeeting/attachmentEvidence/addEvidence' }, data)
        return newrequest
}

    /* 点击质证创建房间 */
export const createRoom = (data,type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/attachmentEvidence/createRoom' }, data) : http({ url: '/videoMeeting/attachmentEvidence/createRoom' }, data)
        return newrequest
}









/**
 * 视频会议
 */

// 查看调解笔录接口
export const viewMediationRecord = (data) => {
    return http({ url: '/videoMeeting/mediationRecord/viewMediationRecord' }, data)
}

// 发送调解笔录接口
export const sendMediationRecord = (data) => {
    return http({ url: '/videoMeeting/mediationRecord/sendMediationRecord' }, data)
}

// 保存调解笔录接口
export const saveMediationRecord = (data) => {
    return http({ url: '/videoMeeting/mediationRecord/saveMediationRecord' }, data)
}

// 当事人获取承诺书接口
export const viewMediationPromise = (data) => {
    return http({ url: '/videoMeeting/mediationPromise/viewMediationPromise' }, data)
}

// 当事人同意承诺书接口
export const confirmMediationPromise = (data) => {
    return http({ url: '/videoMeeting/mediationPromise/confirmMediationPromise' }, data)
}

// 当事人拒绝承诺书接口
export const refuseMediationPromise = (data) => {
    return http({ url: '/videoMeeting/mediationPromise/refuseMediationPromise' }, data)
}

// 当事人查看异议书接口
export const viewMediationDissent = (data) => {
    return http({ url: '/videoMeeting/mediationDissent/viewMediationDissent' }, data)
}

// 当事人发送异议书接口
export const sendMediationDissent = (data) => {
    return http({ url: '/videoMeeting/mediationDissent/sendMediationDissent' }, data)
}

// 当事人保存异议书接口
export const saveMediationDissent = (data) => {
        return http({ url: '/videoMeeting/mediationDissent/saveMediationDissent' }, data)
    }
    // 当事人获取协议书
export const getProtocolBook = (data, type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/document/getProtocolBook' }, data) : http({ url: '/videoMeeting/document/getProtocolBook' }, data)
    return newrequest
}

    // 调解员获取仲裁协议书获取协议书
export const getArbitrationBookByMediator = (data, type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/arbitrationBook/getArbitrationBookByMediator' }, data) : http({ url: '/videoMeeting/arbitrationBook/getArbitrationBookByMediator' }, data)
    return newrequest
}
    // 用户获取仲裁协议书
export const getArbitrationBookByUser = (data, type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/arbitrationBook/getArbitrationBookByUser' }, data) : http({ url: '/videoMeeting/arbitrationBook/getArbitrationBookByUser' }, data)
    return newrequest
}
    // 保存仲裁协议书
export const saveArbitrationBook = (data) => {
    return http({ url: "/videoMeeting/arbitrationBook/saveArbitrationBook" }, data);
}
//     // 发送仲裁协议书
// export const sendArbitrationBook = (data) => {
//     return http({ url: "/videoMeeting/arbitrationBook/sendArbitrationBook" }, data);
// }


// 当事人同意协议书
export const agreeProtocolBook = (data) => {
    return http({ url: '/videoMeeting/document/agreeProtocolBook' }, data)
}

// 当事人拒绝协议书
export const refuseProtocolBook = (data) => {
    return http({ url: "/videoMeeting/clerkConfirm/refuseProtocolBook" }, data);
}

// 获取无异议调解方案
export const getMediationScheme = (data) => {
    return http({ url: '/videoMeeting/document/getMediationScheme' }, data)
}

// 文件上传
export const dossierUpload = (data) => {
        return http({ url: '/videoMeeting/lawCaseDossier/dossierUpload' }, data)
    }
    // 文件上传(多文件)
export const batchFilesUpload = (data) => {
    return http({ url: '/videoMeeting/file/batchFilesUpload' }, data)
}

// 视频期间删除文件
export const delFile = (data) => {
    return http({ url: '/videoMeeting/lawCaseDossier/delFile' }, data)
}

// 案件详情
export const getMediationInfo = (data, type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/envCase/getEnvCase' }, data) : http({ url: '/videoMeeting/envCase/getEnvCase' }, data)
    return newrequest
}

// 查询调解文书的各方签名状态
export const getAllMediationClerkConfirm = (data, type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/clerkConfirm/getAllMediationClerkConfirm' }, data) : http({ url: '/videoMeeting/clerkConfirm/getAllMediationClerkConfirm' }, data)
    return newrequest
}

// 查询某用户对调解文书的签名状态
export const getMediationClerkConfirm = (data) => {
        return http({ url: '/videoMeeting/clerkConfirm/getMediationClerkConfirm' }, data)
    }
    // 保存协议书
export const saveProtocolBook = (data) => {
    return http({ url: '/videoMeeting/document/saveProtocolBook' }, data)
}

// 发送协议书
export const sendMediationProtocolBook = (data) => {
    return http({ url: '/videoMeeting/document/sendMediationProtocolBook' }, data)
}

// 保存承诺书
export const savePromise = (data) => {
    return http({ url: '/videoMeeting/document/savePromise' }, data)
}



// 通过会议id更新开始时间
export const updateStart = (data) => {
    return http({ url: '/videoMeeting/caseMeeting/updateStart' }, data)
}

// 输入邀请码进入视频
export const inviteWatch = (data) => {
    return http({ url: '/videoMeeting/caseMeeting/inviteWatch' }, data)
}

// 调解文件材料类型
export const materialType = (data, type) => {
        let newrequest = type ? meetingHttp({ url: '/videoMeeting/file/materialType' }, data) : http({ url: '/videoMeeting/file/materialType' }, data)
        return newrequest
    }
    // 邀请观摩人
export const inviteSendSms = (data) => {
    return http({ url: '/videoMeeting/caseMeeting/inviteSendSms' }, data)
}

// 获取二维码
export const getCodeQr = (data) => {
    return http({ url: '/videoMeeting/caseMeeting/getCodeQr' }, data)
}

// 获取司法确认申请书
export const getJudicialConfirmBook = (data) => {
    return http({ url: '/videoMeeting/judicialConfirm/getJudicialConfirmBook' }, data)
}

// 保存司法确认申请书
export const saveJudicialConfirmBook = (data) => {
    return http({ url: '/videoMeeting/judicialConfirm/saveJudicialConfirmBook' }, data)
}

// 发送司法确认申请书
export const sendJudicialConfirmBook = (data) => {
    return http({ url: '/videoMeeting/judicialConfirm/sendJudicialConfirmBook' }, data)
}

// 法院json地址
export const court = (data) => {
        return http({ url: '/arbit/court/court.json', method: 'get' }, data)
    }
    /* 申请诉讼 */
export const getSuitBaseInfo = (data) => {
    return http({
        url: '/arbit/suit/getSuitBaseInfo',
        method: 'post'
    }, data)
}

/* 获取案由 - 申请诉讼 */
export const getlawCause = (data, jsonfile) => {
        return http({
            url: '/arbit/lawCause/' + jsonfile,
            method: 'get'
        }, data)
    }
    /* 调解笔录- 案件详情 */
    // export const queryMeetingList = (data, type) => {
    //         let newrequest = type ? meetingHttp({ url: '/videoMeeting/caseMeeting/queryMeetingList' }, data) : http({ url: '/videoMeeting/caseMeeting/queryMeetingList' }, data)
    //         return newrequest
    //     }
    /* 文书材料证据材料- 案件详情 */
export const getMediatorDocuments = (data, type) => {
        let newrequest = type ? meetingHttp({ url: '/videoMeeting/mediation/getMediatorDocuments' }, data) : http({ url: '/videoMeeting/mediation/getMediatorDocuments' }, data)
        return newrequest
    }
    /* 工作台文书- 案件详情 */
export const getMediationWorkbenchs = (data, type) => {
    let newrequest = type ? meetingHttp({ url: '/videoMeeting/mediation/getMediationWorkbenchs' }, data) : http({ url: '/videoMeeting/mediation/getMediationWorkbenchs' }, data)
    return newrequest
}

// 获取待确认文书列表
export const getWaitSignDocumentList = (data) => {
    return http({ url: '/videoMeeting/document/getWaitSignDocumentList' }, data)
}

// 批量签名二维码
export const batchSignCode = (data) => {
    return http({ url: '/videoMeeting/document/batchSignCode' }, data)
}

//私聊
export const videoPrivateChat = (data) => {
    return http({ url: '/videoMeeting/caseMeeting/videoPrivateChat' }, data)
}


// 获取语音识别key
export const getVoiceRecogKey = (data) => {
    return http({ url: '/basicGateway/voiceRecog/getVoiceRecogKey' }, data)
}

//上传笔录接口 
export const uploadClerkRecord = (data) => {
    return http({ url: "/videoMeeting/clerkRecord/uploadClerkRecord", method: 'post' }, data);
}

//获取所有受邀邀请码
export const getAllMeetingUserInviteCode = (data) => {
    return http({ url: "/videoMeeting/meeting/getAllMeetingUserInviteCode", method: 'post' }, data);
}